<template>
  <div class="container" style="max-width:400px; margin:80px auto;">
    <LoginForm />
  </div>
</template>

<script>
import LoginForm from "../components/LoginForm.vue";
export default { components: { LoginForm } };
</script>
